import { render } from "./docs.vue?vue&type=template&id=39065b08&scoped=true"
import script from "./docs.vue?vue&type=script&lang=js"
export * from "./docs.vue?vue&type=script&lang=js"

import "./docs.vue?vue&type=style&index=0&id=39065b08&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39065b08"]])

export default __exports__